export const STEPS = {
  HOME: 'HOME',
  STANDALONE_HOME: 'STANDALONE_HOME',
  LOADING: 'LOADING',
  VIDEO_UPLOAD: 'VIDEO_UPLOAD',
  PHOTO_UPLOAD: 'PHOTO_UPLOAD',
  UPLOADING: 'UPLOADING',
  TARGET_UPLOAD_SUCCESS: 'TARGET_UPLOAD_SUCCESS',
  ALBUM_SELECT: 'ALBUM_SELECT',
  GIFTING: 'GIFTING',
  GIFTING_SUCCESS: 'GIFTING_SUCCESS',
};
